"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashString = void 0;
var hashString = function hashString(str) {
  var h = 0,
    l = str.length,
    i = 0;
  if (l > 0) while (i < l) h = (h << 5) - h + str.charCodeAt(i++) | 0;
  return h;
};
exports.hashString = hashString;